import { pathgen } from 'object-path-generator';
import { Box, Card, ConfirmationModal, FullRow, Typography } from 'seagull';
import styles from "./SelectNewServiceTypeModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let NewServiceType = /*#__PURE__*/function (NewServiceType) {
  NewServiceType["Service"] = "service";
  NewServiceType["Bundle"] = "bundle";
  return NewServiceType;
}({});
export const SelectNewServiceTypeModalTID = pathgen('SelectNewServiceTypeModalTID');
const buttonTypeToTestId = {
  [NewServiceType.Service]: SelectNewServiceTypeModalTID.Service(),
  [NewServiceType.Bundle]: SelectNewServiceTypeModalTID.Bundle()
};
export function SelectNewServiceTypeModal(_ref) {
  let {
    dismissModal
  } = _ref;
  const buttons = [{
    type: NewServiceType.Service,
    title: 'Create a new service',
    content: 'Set up a single service with its price and details.'
  }, {
    type: NewServiceType.Bundle,
    title: 'Create a new bundle',
    content: 'Combine multiple services into one offering with a single price.'
  }];
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    showFooter: false,
    title: "Create new",
    width: "540px",
    testId: SelectNewServiceTypeModalTID.Root(),
    onCloseButtonClick: () => dismissModal(),
    contentClassName: styles.content,
    content: /*#__PURE__*/_jsx(FullRow, {
      centered: true,
      gap: 16,
      children: buttons.map(_ref2 => {
        let {
          title,
          content,
          type
        } = _ref2;
        return /*#__PURE__*/_jsx(Box, {
          className: styles.button,
          children: /*#__PURE__*/_jsx(Card, {
            as: "button",
            skin: "button",
            highlightOnHover: true,
            padding: "s",
            testId: buttonTypeToTestId[type],
            className: styles.card,
            onClick: () => dismissModal(type),
            children: /*#__PURE__*/_jsxs(Box, {
              className: styles.cardContent,
              children: [/*#__PURE__*/_jsx(Typography, {
                weight: "normal",
                variant: "paragraph1",
                children: title
              }), /*#__PURE__*/_jsx(Typography, {
                skin: "secondary",
                variant: "paragraph2",
                weight: "light",
                children: content
              })]
            })
          })
        }, title);
      })
    })
  });
}